import { render, staticRenderFns } from "./TrainingFollowUp.vue?vue&type=template&id=a90ab968&scoped=true"
import script from "./TrainingFollowUp.vue?vue&type=script&lang=js"
export * from "./TrainingFollowUp.vue?vue&type=script&lang=js"
import style0 from "./TrainingFollowUp.vue?vue&type=style&index=0&id=a90ab968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90ab968",
  null
  
)

export default component.exports